import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import Widget from "components/widget/Widget";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import { API_BASE_URL } from "../../../config";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${API_BASE_URL}/api/admin/get-dashboard-detail`,
          {
            headers: {
              token,
            },
          }
        );

        if (res.data.success) {
          setDashboardData(res.data.result);
        } else {
          toast.error(res.data.message || "Failed to fetch dashboard");
        }
      } catch (error) {
        // console.error(error);
        toast.error("Error fetching dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  if (loading) {
    return <p className="mt-10 text-center dark:text-white">Loading dashboard...</p>;
  }

  if (!dashboardData) {
    return <p className="mt-10 text-center text-red-500">No data available</p>;
  }

  return (
    <div>
    
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Revenue"}
          subtitle={`₹${dashboardData.totalRevenue?.toLocaleString("en-IN")}`}
          colorVariant="default"
        />
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={"Total Visits"}
          subtitle={dashboardData.totalVisits}
          colorVariant="amber"
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Calls"}
          subtitle={dashboardData.totalCalls}
          colorVariant="orange"
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Total Customers"}
          subtitle={dashboardData.totalCustomers}
          colorVariant="orange"
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Finalized Deals"}
          subtitle={dashboardData.totalFinalizedDeals}
          colorVariant="amber"
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Total Active Projects"}
          subtitle={dashboardData.totalProjects}
          colorVariant="default"
        />
      </div>

   
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="h-full">
          <TotalSpent />
        </div>
        <div className="h-full">
          <WeeklyRevenue />
        </div>
      </div>

   
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div className="h-full">
          <DailyTraffic />
        </div>
        <div className="h-full">
          <PieChartCard />
        </div>
        <div className="h-full">
          <MiniCalendar />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
